import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

import Error from '../pages/Error'
import Forbidden from '../pages/Forbidden'
import NotFound from '../pages/NotFound'

// mmstyle
import DcLogin from '../payment/pages/DcLogin'
import DcTop from '../payment/pages/DcTop'
// import DcUserManager from '../payment/pages/DcUserManager'
// import SendMail from '../payment/pages/DcSendMail'
import SendMailComp from '../payment/pages/DcSendMailComplete'
// import RegisterCorp from '../payment/pages/DcRegistCorpInput'
// import RegistUserInput from '../payment/pages/DcRegistUserInput'
import RegisterCorp from '../payment/pages/DcRegistUserInput'
import RegistUserConfirm from '../payment/pages/DcRegistUserConfirm'
import RegistUserComplete from '../payment/pages/DcRegistUserComplete'
import UpdateCorpInput from '../payment/pages/DcUpdateCorpInput'
import UpdateUserInput from '../payment/pages/DcUpdateUserInput'
import UpdateAccountConfirm from '../payment/pages/DcUpdateAccountConfirm'
import UpdateAccountComplete from '../payment/pages/DcUpdateAccountComplete'
import UpdateAccountInput from '../payment/pages/DcUpdateAccountInput'
import UpdatePasswordInput from '../payment/pages/DcUpdatePasswordInput'
// import UpdateUserConfirm from '../payment/pages/DcUpdateUserConfirm'
import OrderInput from '../payment/pages/DcOrderInput'
import OrderConfirm from '../payment/pages/DcOrderConfirm'
import ConstructInput from '../payment/pages/DcConstructInput'
import OrderComplate from '../payment/pages/DcOrderComplete'
import SupportInput from '../payment/pages/DcSupportInput'
import SupportConfirm from '../payment/pages/DcSupportConfirm'
import SupportComplete from '../payment/pages/DcSupportComplete'
import UseRule from '../payment/pages/DcUseRule'
import Faq from '../payment/pages/DcFaq'
import What from '../payment/pages/DcWhatMmStyle'
import DcError from '../payment/pages/DcError'
import UnSupported from '../components/common/UnSupported'
import PasswordResetInput from '../payment/pages/DcPasswordResetInput'
import PasswordResetConfirm from '../payment/pages/DcPasswordResetConfirm'
import PasswordResetUpdate from '../payment/pages/DcPasswordResetUpdate'
import PasswordResetComplete from '../payment/pages/DcPasswordResetComplete'
import BuildingResearchBusiness from '../payment/pages/DcBuildingResearchBusiness'
import BuildingResearchInput from '../payment/pages/DcBuildingResearchInput'
import BuildingResearchConfirm from '../payment/pages/DcBuildingResearchConfirm'
import BuildingResearchComplete from '../payment/pages/DcBuildingResearchComplete'
import FirstPassword from '../payment/pages/DcFirstPassword'
import SaveItemList from '../payment/pages/DcSaveItemList'
import Cart from '../payment/pages/DcCart'
// import OrderHistoryList from '../payment/pages/DcOrderHistoryList'
import DcMyPage from '../payment/pages/DcMyPage'
import DcUserAccount from '../payment/pages/DcUserAccount'
import DcOrderHistoryList from '../payment/pages/DcOrderHistoryList'
import DcOrderHistoryDetail from '../payment/pages/DcOrderHistoryDetail'
import DcResearchHistoryList from '../payment/pages/DcResearchHistoryList'
import DcResearchHistoryDetail from '../payment/pages/DcResearchHistoryDetail'
import DcDeliveryList from '../payment/pages/DcDeliveryList'
import DcUserManager from '../payment/pages/DcUserManager'
import DcProfitSetting from '../payment/pages/DcProfitSetting'
import DcCategory from '../payment/pages/DcCategory'
import DcPrpic from '../payment/pages/DcPrpic'
import DcAbout from '../payment/pages/DcAbout'
import DcAbout2 from '../payment/pages/DcAbout2'
import DcConstructModel from '../payment/pages/DcConstructModel'
import DcPaymentGuide from '../payment/pages/DcPaymentGuide'
import DcCorpInformation from '../payment/pages/DcCorpInformation'
import DcTokutei from '../payment/pages/DcTokutei'
import DcSignUp from '../payment/pages/DcSignUp'
import DcSignIn from '../payment/pages/DcSignIn'
import DcSpecialPrice from '../payment/pages/DcSpecialPrice'
import DcNews from '../payment/pages/DcNews'
import DcOrderSignIn from '../payment/pages/DcOrderSignIn'
import DcPaymentSelect from '../payment/pages/DcPaymentSelect'
import DcOrderGuest from '../payment/pages/DcOrderGuest'
import DcCustomize from '../payment/pages/DcCustomize'
import DcSketchOrder from '../payment/pages/DcSketchOrder'
import DcSketchUpload from '../payment/pages/DcSketchUpload'
import DcSketchUploadConfirm from '../payment/pages/DcSketchUploadConfirm'
import DcSketchUploadComplete from '../payment/pages/DcSketchUploadComplete'
import DcSeriesPage from '../payment/pages/DcSeriesPage'
import DcPaymentService from '../payment/pages/DcPaymentService'
import DcClientInput from '../payment/pages/DcClientInput'
import DcClientComplete from '../payment/pages/DcClientComplete'
import DcPersonSelect from '../payment/pages/DcPersonSelect'
import DcRedirectPayment from '../payment/pages/DcRedirectPayment'

import {API_URL, APP_NAME, DC_APP_NAME, PTN_DC, KG_APP_NAME, PTN_KG, PTN_KG_SHEET} from '../constants/App'
import * as Api from '../utils/Api'
import * as AppUtil from '../utils/App'
import * as Check from '../utils/Check'
import {LICENSE_TYPE} from '../constants/Type'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    // 事前現場調査入力画面
    {
      path: '/mmstyle/research/business',
      name: 'BuildingResearchBusiness',
      component: BuildingResearchBusiness,
      meta: {
        title: '事前現場調査内容入力'
      }
    },
    // 事前現場調査入力画面
    {
      path: '/mmstyle/research/input',
      name: 'BuildingResearchInput',
      component: BuildingResearchInput,
      meta: {
        title: '事前現場調査内容入力'
      }
    },
    // 事前現場調査確認画面
    {
      path: '/mmstyle/research/confirm',
      name: 'BuildingResearchConfirm',
      component: BuildingResearchConfirm,
      meta: {
        title: '事前現場調査依頼確認'
      }
    },
    // 事前現場調査完了画面
    {
      path: '/mmstyle/research/complete',
      name: 'BuildingResearchComplete',
      component: BuildingResearchComplete,
      meta: {
        title: '事前現場調査依頼完了'
      }
    },
    // mmstyle初回ログイン画面
    {
      path: '/mmstyle/password',
      name: 'FirstPassword',
      component: FirstPassword
    },
    // デジタルカタログ
    {
      path: '/mmstyle/login',
      name: 'DcLogin',
      component: DcLogin,
      meta: {
        title: 'mm/style 会員登録'
      }
    },
    {
      path: '/mmstyle/order/person-select',
      name: 'DcPersonSelect',
      component: DcPersonSelect,
      meta: {
        title: '担当者入力'
      }
    },
    {
      path: '/mmstyle/top',
      name: 'DcTop',
      component: DcTop,
      meta: {
        title: 'サイズオーダー収納の専門店 mm/style（ミリスタイル）'
      }
    },
    {
      path: '/',
      name: 'DcTop',
      component: DcTop,
      meta: {
        title: 'サイズオーダー収納の専門店 mm/style（ミリスタイル）'
      }
    },
    // // デジタルカタログ
    // {
    //   path: '/mmstyle/user/manager',
    //   name: 'DcUserManager',
    //   component: DcUserManager,
    //   meta: {
    //     title: 'ユーザ管理',
    //     requiresAuth: true,
    //     requireMessenger: true
    //   }
    // },
    // デジタルカタログ 仮メール送信完了
    {
      path: '/mmstyle/user/mail-comp',
      name: 'SendMailComp',
      component: SendMailComp,
      meta: {
        title: 'ユーザ仮登録メール送信完了'
      }
    },
    // デジタルカタログ ユーザ新規登録
    {
      path: '/mmstyle/user/register',
      name: 'RegisterCorp',
      component: RegisterCorp,
      meta: {
        title: 'ユーザ情報入力'
      }
    },
    // デジタルカタログ ユーザ新規登録
    {
      path: '/mmstyle/user/confirm',
      name: 'RegistUserConfirm',
      component: RegistUserConfirm,
      meta: {
        title: 'ユーザ登録確認'
      }
    },
    // デジタルカタログ ユーザ新規登録
    {
      path: '/mmstyle/user/complete',
      name: 'RegistUserComplete',
      component: RegistUserComplete,
      meta: {
        title: 'ユーザ登録完了'
      }
    },
    // デジタルカタログ ユーザ情報 更新
    {
      path: '/mmstyle/user/update-corp',
      name: 'UpdateCorpInput',
      component: UpdateCorpInput,
      meta: {
        title: '企業情報入力',
        requiresAuth: true
      }
    },
    // デジタルカタログ ユーザ情報 更新
    {
      path: '/mmstyle/user/update-user',
      name: 'UpdateUserInput',
      component: UpdateUserInput,
      meta: {
        title: 'ユーザ情報入力',
        requiresAuth: true
      }
    },
    // デジタルカタログ アカウント情報 更新入力
    {
      path: '/mmstyle/user/update-account-input',
      name: 'UpdateAccountInput',
      component: UpdateAccountInput,
      meta: {
        title: 'アカウント情報入力',
        requiresAuth: true
      }
    },
    // // デジタルカタログ アカウント情報 更新確認
    {
      path: '/mmstyle/user/update-account-confirm',
      name: 'UpdateAccountConfirm',
      component: UpdateAccountConfirm,
      meta: {
        title: 'アカウント更新確認',
        requiresAuth: true
      }
    },
    // デジタルカタログ アカウント情報 更新確認
    {
      path: '/mmstyle/user/reset/update-account',
      name: 'UpdateAccountComplete',
      component: UpdateAccountComplete,
      meta: {
        title: 'アカウント更新完了'
      }
    },
    {
      path: '/mmstyle/mypage',
      name: 'DcMyPage',
      component: DcMyPage,
      meta: {
        title: 'マイページ',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/mypage/user-account',
      name: 'DcUserAccount',
      component: DcUserAccount,
      meta: {
        title: 'アカウント管理',
        requiresAuth: true
      }
    },
    // デジタルカタログ パスワード情報 更新
    {
      path: '/mmstyle/user/update-password',
      name: 'UpdatePasswordInput',
      component: UpdatePasswordInput,
      meta: {
        title: 'パスワード情報入力',
        requiresAuth: true
      }
    },
    // デジタルカタログ 利用規約
    {
      path: '/mmstyle/user/use-rule',
      name: 'UseRule',
      component: UseRule,
      meta: {
        title: '利用規約',
        requireMessenger: true
      }
    },
    {
      path: '/mmstyle/order/input',
      name: 'OrderInput',
      component: OrderInput,
      meta: {
        title: '注文入力',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/order/confirm',
      name: 'OrderConfirm',
      component: OrderConfirm,
      meta: {
        title: '注文確認',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/order/complete',
      name: 'OrderComplate',
      component: OrderComplate,
      meta: {
        title: '注文完了',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/order/construct',
      name: 'ConstructInput',
      component: ConstructInput,
      meta: {
        title: '組立設置',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/support/input',
      name: 'SupportInput',
      component: SupportInput,
      meta: {
        title: 'お問い合わせ入力'
      }
    },
    {
      path: '/mmstyle/support/confirm',
      name: 'SupportConfirm',
      component: SupportConfirm,
      meta: {
        title: 'お問い合わせ確認'
      }
    },
    {
      path: '/mmstyle/support/complete',
      name: 'SupportComplete',
      component: SupportComplete,
      meta: {
        title: 'お問い合わせ完了'
      }
    },
    {
      path: '/mmstyle/faq',
      name: 'Faq',
      component: Faq,
      meta: {
        title: 'よくある質問',
        requireMessenger: true
      }
    },
    {
      path: '/mmstyle/what',
      name: 'What',
      component: What,
      meta: {
        title: 'mm/styleとは',
        requireMessenger: true
      }
    },
    {
      path: '/mmstyle/user/reset/input',
      name: 'PasswordResetInput',
      component: PasswordResetInput,
      meta: {
        title: 'パスワードリセット'
      }
    },
    {
      path: '/mmstyle/user/reset/confirm',
      name: 'PasswordResetConfirm',
      component: PasswordResetConfirm,
      meta: {
        title: 'パスワードリセット完了'
      }
    },
    {
      path: '/mmstyle/user/reset/update',
      name: 'PasswordResetUpdate',
      component: PasswordResetUpdate,
      meta: {
        title: 'パスワードリセット'
      }
    },
    {
      path: '/mmstyle/user/reset/complete',
      name: 'PasswordResetComplete',
      component: PasswordResetComplete,
      meta: {
        title: 'パスワードリセット完了'
      }
    },
    {
      path: '/mmstyle/save/itemlist',
      name: 'SaveItemList',
      component: SaveItemList,
      meta: {
        title: '商品保存リスト',
        requireMessenger: true
      }
    },
    {
      path: '/mmstyle/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        title: 'カート',
        requireMessenger: true
      }
    },
    // {
    //   path: '/mmstyle/order/history',
    //   name: 'OrderHistoryList',
    //   component: OrderHistoryList,
    //   meta: {
    //     title: '注文履歴',
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/mmstyle/mypage/history-list',
      name: 'DcOrderHistoryList',
      component: DcOrderHistoryList,
      meta: {
        title: '注文履歴リスト',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/mypage/history-detail',
      name: 'DcOrderHistoryDetail',
      component: DcOrderHistoryDetail,
      meta: {
        title: '注文履歴詳細',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/mypage/research-list',
      name: 'DcResearchHistoryList',
      component: DcResearchHistoryList,
      meta: {
        title: '事前現場調査リスト',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/mypage/research-detail',
      name: 'DcResearchHistoryDetail',
      component: DcResearchHistoryDetail,
      meta: {
        title: '事前現場調査詳細',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/mypage/delivery-list',
      name: 'DcDeliveryList',
      component: DcDeliveryList,
      meta: {
        title: '配送先リスト',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/mypage/user-manager',
      name: 'DcUserManager',
      component: DcUserManager,
      meta: {
        title: '企業ユーザ管理',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/top/profit',
      name: 'DcProfitSetting',
      component: DcProfitSetting,
      meta: {
        title: '価格表示設定',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/top/customize',
      name: 'DcCustomize',
      component: DcCustomize,
      meta: {
        title: 'カスタマイズ'
      }
    },
    {
      path: '/mmstyle/top/category',
      name: 'DcCategory',
      component: DcCategory,
      meta: {
        title: '商品カテゴリ'
      }
    },
    {
      path: '/mmstyle/top/category-prpic',
      name: 'DcPrpic',
      component: DcPrpic,
      meta: {
        title: '商品カテゴリ'
      }
    },
    {
      path: '/mmstyle/top/about',
      name: 'DcAbout',
      component: DcAbout,
      meta: {
        title: 'はじめてのお客様へ'
      }
    },
    {
      path: '/mmstyle/top/rashiku/about',
      name: 'DcAbout2',
      component: DcAbout2,
      meta: {
        title: 'はじめてのお客様へ'
      }
    },
    {
      path: '/mmstyle/top/construct',
      name: 'DcConstructModel',
      component: DcConstructModel,
      meta: {
        title: '施工事例'
      }
    },
    {
      path: '/mmstyle/top/payment-guide',
      name: 'DcPaymentGuide',
      component: DcPaymentGuide,
      meta: {
        title: 'ご購入ガイド'
      }
    },
    {
      path: '/mmstyle/top/corp-info',
      name: 'DcCorpInformation',
      component: DcCorpInformation,
      meta: {
        title: '会社案内'
      }
    },
    {
      path: '/mmstyle/top/tokutei',
      name: 'DcTokutei',
      component: DcTokutei,
      meta: {
        title: '特定商取引法の表示'
      }
    },
    {
      path: '/mmstyle/top/sign-up',
      name: 'DcSignUp',
      component: DcSignUp,
      meta: {
        title: '新規会員登録'
      }
    },
    {
      path: '/mmstyle/top/sign-in',
      name: 'DcSignIn',
      component: DcSignIn,
      meta: {
        title: 'ログイン'
      }
    },
    {
      path: '/mmstyle/top/specialprice',
      name: 'DcSpecialPrice',
      component: DcSpecialPrice,
      meta: {
        title: '特別仕切り価格'
      }
    },
    {
      path: '/mmstyle/top/news',
      name: 'DcNews',
      component: DcNews,
      meta: {
        title: 'ニュース'
      }
    },
    {
      path: '/mmstyle/order/sign-in/:type',
      name: 'DcOrderSignIn',
      component: DcOrderSignIn,
      meta: {
        title: '購入前ログイン'
      }
    },
    {
      path: '/mmstyle/order/payment-select',
      name: 'DcPaymentSelect',
      component: DcPaymentSelect,
      meta: {
        title: '決済方法選択'
      }
    },
    {
      path: '/mmstyle/order/guest',
      name: 'DcOrderGuest',
      component: DcOrderGuest,
      meta: {
        title: '発注者情報入力'
      }
    },
    {
      path: '/mmstyle/top/sketch/order',
      name: 'DcSketchOrder',
      component: DcSketchOrder,
      meta: {
        title: 'スケッチオーダー'
      }
    },
    {
      path: '/mmstyle/top/sketch/upload',
      name: 'DcSketchUpload',
      component: DcSketchUpload,
      meta: {
        title: 'スケッチアップロード'
      }
    },
    {
      path: '/mmstyle/top/sketch/confirm',
      name: 'DcSketchUploadConfirm',
      component: DcSketchUploadConfirm,
      meta: {
        title: 'スケッチアップロード確認'
      }
    },
    {
      path: '/mmstyle/top/sketch/complete',
      name: 'DcSketchUploadComplete',
      component: DcSketchUploadComplete,
      meta: {
        title: 'スケッチアップロード完了'
      }
    },
    {
      path: '/mmstyle/top/series',
      name: 'DcSeriesPage',
      component: DcSeriesPage,
      meta: {
        title: 'シリーズページ'
      }
    },
    {
      path: '/mmstyle/top/payment-service',
      name: 'DcPaymentService',
      component: DcPaymentService,
      meta: {
        title: '事業者様向け「後払い」サービスのご案内'
      }
    },
    {
      path: '/mmstyle/top/client-input',
      name: 'DcClientInput',
      component: DcClientInput,
      meta: {
        title: '顧客登録申し込み'
      }
    },
    // {
    //   path: '/mmstyle/top/client-confirm',
    //   name: 'DcClientConfirm',
    //   component: DcClientConfirm,
    //   meta: {
    //     title: '顧客登録申し込み確認'
    //   }
    // },
    {
      path: '/mmstyle/top/client-complete',
      name: 'DcClientComplete',
      component: DcClientComplete,
      meta: {
        title: '顧客登録申し込み完了'
      }
    },
    {
      path: '/mmstyle/order/payment-redirect',
      name: 'DcRedirectPayment',
      component: DcRedirectPayment,
      meta: {
        title: '支払いリダイレクト'
      }
    },
    // 共通
    {
      path: '/error',
      name: 'Error',
      component: Error,
      meta: {}
    },
    //
    {
      path: '/mmstyle/error',
      name: 'DcError',
      component: DcError,
      meta: {}
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden,
      meta: {}
    },
    {
      path: '/unsupported',
      name: 'UnSupported',
      component: UnSupported,
      meta: {}
    },
    {
      path: '/mmstyle/unsupported',
      name: 'UnSupported',
      component: UnSupported,
      meta: {}
    },
    // 必ず最後に定義
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {}
    }
  ],
  scrollBehavior (to, from, savePosiotn) {
    return {x: 0, y: 0}
  }
})

// axiosのキャッシュ設定
axios.interceptors.request.use(function (config) {
  if (typeof config.params === 'undefined') {
    config.params = {}
  }
  if (typeof config.params === 'object') {
    if (typeof URLSearchParams === 'function' && config.params instanceof URLSearchParams) {
      config.params.append('_', Date.now())
    } else {
      config.params._ = Date.now()
    }
  }

  return config
})

/** タイトル設定 */
const setTitle = function (to) {
  let component = to.matched.find(e => e.meta.title)
  let url = location.href
  if (PTN_KG.test(url)) {
    document.title = component ? component.meta.title : KG_APP_NAME
  } else if (PTN_DC.test(url)) {
    document.title = component ? component.meta.title : DC_APP_NAME
  } else {
    document.title = component ? component.meta.title : APP_NAME
  }
}

/** Intercomのメッセンジャーの表示 */
const dispMessenger = function (to) {
  window.Intercom('shutdown')
  if (to.matched.some(e => e.meta.requireMessenger)) {
    window.Intercom('boot', {
      app_id: 'vpld6oei',
      vertical_padding: 1,
      horizontal_padding: 23
    })
  }
}

/** ズームイン・ズームアウトの可否を設定 */
const setUserScaleNo = function () {
  let url = location.href
  let userNoScale = 'user-scalable=no'
  let viewport = document.querySelector('meta[name="viewport"]')
  let viewportContent = viewport.getAttribute('content')
  if (PTN_KG.test(url) && !PTN_KG_SHEET.test(url)) {
    // ズームイン・ズームアウトが不可に設定されていなかったら不可に設定する
    if (!viewportContent.match(userNoScale)) {
      viewport.setAttribute('content', viewportContent + ', ' + userNoScale)
    }
  } else {
    // ズームイン・ズームアウトが不可に設定されていたら可能に設定する
    if (viewportContent.match(userNoScale)) {
      let replaceViewportContent = viewportContent.replace(userNoScale, '').replace(/, $/, '')
      viewport.setAttribute('content', replaceViewportContent)
    }
  }
}

// 画面初期表示時にサーバーアクセスがないものについては、vue-routerの機能を利用して画面描画開始前に認証処理を行う。
router.beforeEach((to, from, next) => {
  // オーダースケッチ
  if (process.env.SKETCH_ORDER === 0) {
    if (to.path.indexOf('sketch') >= 0) {
      next('/mmstyle/error')
      setTitle(to)
      next()
      dispMessenger(to)
      return
    }
  }

  if (to.path.indexOf('unsupported') === -1) {
    let url = location.href
    if (PTN_DC.test(url)) {
      if (!Check.brawserCheck()) {
        if (from.path.indexOf('unsupported') >= 0) {
          next(false)
        } else {
          next('/mmstyle/unsupported')
          setTitle(to)
          next()
          dispMessenger(to)
        }
        return
      }
    }
  }

  // 画面初期表示時、認証チェック
  if (to.matched.some(e => e.meta.requiresAuth)) {
    axios.get(API_URL.INIT, {
      params: {
        pageUrl: to.path
      }
    }).then(response => {
      // お試しユーザーに許容していない画面はプランニング画面に遷移させる
      if (to.matched.some(e => e.meta.notPermitTrial) && AppUtil.getUserInfo().licenseType === LICENSE_TYPE.TRIAL) {
        router.push('/planning')
      } else {
        setTitle(to)
        next()
        dispMessenger(to)
        setUserScaleNo()
      }
    }).catch(error => {
      Api.handleError(error)
    })
    return
  }
  setTitle(to)
  next()
  dispMessenger(to)
  setUserScaleNo()
})

export default router



// WEBPACK FOOTER //
// ./src/main/js/router/index.js